import React from 'react';
import { getText } from '../i18n';

export default function DailyFlagInput({
  value,
  onChange,
  onKeyDown,
  onSubmit,
  placeholder,
  language,
  disabled,
  submitLabel,
  inputRef,
}) {
  return (
    <form className="daily-flag-form" onSubmit={onSubmit}>
      <div className="daily-flag-input-row">
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          className="daily-flag-input"
          autoFocus
        />
        <button
          type="submit"
          className="daily-flag-submit"
          disabled={disabled}
        >
          {submitLabel || getText('dailyGuessButton', language)}
        </button>
      </div>
    </form>
  );
}
